module.exports = __webpack_public_path__ + "img/blue-edit-icon.e88cab4d.svg";